module.exports = __webpack_public_path__ + "img/rural-icon.1dca61f6.svg";